// import React, { useState, useRef } from "react";
// import { Upload, Button, Avatar, message, Spin, Popconfirm, Typography, Space } from "antd";
// import { UserOutlined, UploadOutlined, DeleteOutlined } from "@ant-design/icons";
// import axios from "axios";
// import { BASE_URL } from "../Config";

// const { Text } = Typography;

// const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/webp"];
// const MAX_SIZE_MB = 5;

// const getFullUrl = (url) => {
//   if (!url) return null;
//   if (url.startsWith("http")) return url;
//   return `${BASE_URL.replace("/api", "")}${url}`;
// };


// const LogoUpload = ({ currentLogoUrl, onLogoChange }) => {
//  const [preview, setPreview] = useState(getFullUrl(currentLogoUrl));
//   const [uploading, setUploading] = useState(false);
//   const [deleting, setDeleting] = useState(false);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const fileInputRef = useRef(null);

//   const token = sessionStorage.getItem("token");
//   const authHeader = { Authorization: `Bearer ${token}` };

//   // ── Validate before selecting ──────────────────────────────────
//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     if (!ALLOWED_TYPES.includes(file.type)) {
//       message.error("Only .jpg, .png, or .webp images are allowed.");
//       e.target.value = "";
//       return;
//     }
//     if (file.size > MAX_SIZE_MB * 1024 * 1024) {
//       message.error(`File must be under ${MAX_SIZE_MB}MB.`);
//       e.target.value = "";
//       return;
//     }

//     setSelectedFile(file);

//     // Show local preview instantly
//     const reader = new FileReader();
//     reader.onloadend = () => setPreview(reader.result);
//     reader.readAsDataURL(file);
//   };

//   // ── Upload ─────────────────────────────────────────────────────
//   const handleUpload = async () => {
//     if (!selectedFile) {
//       message.warning("Please choose an image first.");
//       return;
//     }

//     setUploading(true);
//     try {
//       const formData = new FormData();
//       formData.append("logo", selectedFile);

//       const res = await axios.post(`${BASE_URL}/users/logo`, formData, {
//         headers: {
//           ...authHeader,
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       if (res.data.success) {
//         message.success("Logo uploaded successfully.");
//        const newUrl = res.data.data.logoUrl;
// setPreview(getFullUrl(newUrl));
//         setSelectedFile(null);
//         if (fileInputRef.current) fileInputRef.current.value = "";
//         onLogoChange && onLogoChange(newUrl);
//       }
//     } catch (err) {
//       message.error(err.response?.data?.error || "Upload failed. Please try again.");
//     } finally {
//       setUploading(false);
//     }
//   };

//   // ── Delete ─────────────────────────────────────────────────────
//   const handleDelete = async () => {
//     setDeleting(true);
//     try {
//       const res = await axios.delete(`${BASE_URL}/users/logo`, {
//         headers: authHeader,
//       });

//       if (res.data.success) {
//         message.success("Logo removed.");
//         setPreview(null);
//         setSelectedFile(null);
//         if (fileInputRef.current) fileInputRef.current.value = "";
//         onLogoChange && onLogoChange(null);
//       }
//     } catch (err) {
//       message.error(err.response?.data?.error || "Delete failed. Please try again.");
//     } finally {
//       setDeleting(false);
//     }
//   };

//   // ── Render ─────────────────────────────────────────────────────
//   return (
//     <div style={styles.wrapper}>
//       {/* Logo preview */}
//       <div style={styles.previewRow}>
//         <Spin spinning={uploading || deleting}>
//           {preview ? (
//             <img
//               src={preview}
//               alt="Profile logo"
//               style={styles.logoImg}
//             />
//           ) : (
//             <Avatar
//               size={90}
//               icon={<UserOutlined />}
//               style={{ background: "#eef2ff", color: "#4f46e5" }}
//             />
//           )}
//         </Spin>

//         <div style={styles.infoCol}>
//           <Text strong style={{ fontSize: 14 }}>Profile Logo</Text>
//           <Text type="secondary" style={{ fontSize: 11, display: "block", marginTop: 2 }}>
//             150 × 150 px · .webp / .jpg / .png · auto-compressed to under 50 KB
//           </Text>

//           <Space style={{ marginTop: 10 }} wrap>
//             {/* Hidden file input */}
//             <input
//               ref={fileInputRef}
//               type="file"
//               accept=".jpg,.jpeg,.png,.webp"
//               onChange={handleFileChange}
//               style={{ display: "none" }}
//               id="logo-input"
//             />

//             {/* Choose file button */}
//             <label htmlFor="logo-input">
//               <Button
//                 icon={<UploadOutlined />}
//                 size="small"
//                 onClick={() => fileInputRef.current?.click()}
//               >
//                 {selectedFile ? "Change" : "Choose image"}
//               </Button>
//             </label>

//             {/* Upload button — only show when a file is selected */}
//             {selectedFile && (
//               <Button
//                 type="primary"
//                 size="small"
//                 loading={uploading}
//                 onClick={handleUpload}
//                 style={{ background: "#4f46e5", borderColor: "#4f46e5" }}
//               >
//                 Upload
//               </Button>
//             )}

//             {/* Delete — only show when a logo exists on server */}
//             {currentLogoUrl && !selectedFile && (
//               <Popconfirm
//                 title="Remove your logo?"
//                 description="This cannot be undone."
//                 onConfirm={handleDelete}
//                 okText="Remove"
//                 okButtonProps={{ danger: true }}
//                 cancelText="Cancel"
//               >
//                 <Button
//                   danger
//                   size="small"
//                   icon={<DeleteOutlined />}
//                   loading={deleting}
//                 >
//                   Remove
//                 </Button>
//               </Popconfirm>
//             )}
//           </Space>

//           {/* Selected file name */}
//           {selectedFile && (
//             <Text type="secondary" style={{ fontSize: 11, display: "block", marginTop: 6 }}>
//               Selected: {selectedFile.name}
//             </Text>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// const styles = {
//   wrapper: {
//     padding: "16px",
//     background: "#fff",
//     borderRadius: 12,
//     border: "1px solid #f0f0f0",
//   },
//   previewRow: {
//     display: "flex",
//     alignItems: "flex-start",
//     gap: 16,
//   },
//   logoImg: {
//     width: 90,
//     height: 90,
//     borderRadius: 10,
//     objectFit: "cover",
//     border: "1px solid #e5e7eb",
//   },
//   infoCol: {
//     flex: 1,
//     display: "flex",
//     flexDirection: "column",
//   },
// };

// export default LogoUpload;

import React, { useState, useRef } from "react";
import { Button, Avatar, message, Spin, Popconfirm, Typography, Space } from "antd";
import { UserOutlined, UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import { BASE_URL } from "../Config";

const { Text } = Typography;

const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/webp"];
const MAX_SIZE_MB = 5;

const getFullUrl = (url) => url ?? null;

const LogoUpload = ({ currentLogoUrl, onLogoChange }) => {
  const [preview, setPreview] = useState(getFullUrl(currentLogoUrl));
  const [uploading, setUploading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  const token = sessionStorage.getItem("token");
  const authHeader = { Authorization: `Bearer ${token}` };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!ALLOWED_TYPES.includes(file.type)) {
      message.error("Only .jpg, .png, or .webp images are allowed.");
      e.target.value = "";
      return;
    }
    if (file.size > MAX_SIZE_MB * 1024 * 1024) {
      message.error(`File must be under ${MAX_SIZE_MB}MB.`);
      e.target.value = "";
      return;
    }

    setSelectedFile(file);
    const reader = new FileReader();
    reader.onloadend = () => setPreview(reader.result);
    reader.readAsDataURL(file);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      message.warning("Please choose an image first.");
      return;
    }

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", selectedFile);

      const res = await axios.post(`${BASE_URL}/users/logo`, formData, {
        headers: { ...authHeader, "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) {
        message.success("Logo uploaded successfully.");
        const newUrl = res.data.data.logoUrl;
        setPreview(getFullUrl(newUrl));
        setSelectedFile(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
        onLogoChange && onLogoChange(newUrl);
      }
    } catch (err) {
      message.error(err.response?.data?.error || "Upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  const handleDelete = async () => {
    setDeleting(true);
    try {
      const res = await axios.delete(`${BASE_URL}/users/logo`, {
        headers: authHeader,
      });

      if (res.data.success) {
        message.success("Logo removed.");
        setPreview(null);
        setSelectedFile(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
        onLogoChange && onLogoChange(null);
      }
    } catch (err) {
      message.error(err.response?.data?.error || "Delete failed. Please try again.");
    } finally {
      setDeleting(false);
    }
  };

  return (
    /* No outer card — sits flush inside the parent card in MainDashboard */
    <div style={{
      display: "flex",
      alignItems: "flex-start",
      gap: 14,
      background: "#fafafa",
      borderRadius: 12,
      padding: 12,
      border: "1px solid #f0f0f0",
    }}>
      {/* Logo preview */}
      <Spin spinning={uploading || deleting}>
        {preview ? (
          <img
            src={preview}
            alt="Profile logo"
            style={{
              width: 60,
              height: 60,
              borderRadius: 10,
              objectFit: "cover",
              border: "1px solid #e5e7eb",
              flexShrink: 0,
            }}
          />
        ) : (
          <Avatar
            size={60}
            icon={<UserOutlined />}
            style={{ background: "#eef2ff", color: "#7c3aed", flexShrink: 0 }}
          />
        )}
      </Spin>

      {/* Info + buttons */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Text strong style={{ fontSize: 13 }}>Profile Logo</Text>
        <Text type="secondary" style={{ fontSize: 11, marginTop: 2, display: "block" }}>
          150 × 150 px • webp / jpg / png •
          auto-compressed to under 50 KB
        </Text>

        <Space style={{ marginTop: 10 }} wrap>
          {/* Hidden file input */}
          <input
            ref={fileInputRef}
            type="file"
            accept=".jpg,.jpeg,.png,.webp"
            onChange={handleFileChange}
            style={{ display: "none" }}
            id="logo-input"
          />

          {/* Choose / Change button */}
          <Button
            icon={<UploadOutlined />}
            size="small"
            onClick={() => fileInputRef.current?.click()}
          >
            {selectedFile ? "Change" : "Choose image"}
          </Button>

          {/* Upload — only when file selected */}
          {selectedFile && (
            <Button
              type="primary"
              size="small"
              loading={uploading}
              onClick={handleUpload}
              style={{ background: "#7c3aed", borderColor: "#7c3aed" }}
            >
              Upload
            </Button>
          )}

          {/* Remove — only when logo exists and no new file chosen */}
          {currentLogoUrl && !selectedFile && (
            <Popconfirm
              title="Remove your logo?"
              description="This cannot be undone."
              onConfirm={handleDelete}
              okText="Remove"
              okButtonProps={{ danger: true }}
              cancelText="Cancel"
            >
              <Button danger size="small" icon={<DeleteOutlined />} loading={deleting}>
                Remove
              </Button>
            </Popconfirm>
          )}
        </Space>

        {/* Selected filename */}
        {selectedFile && (
          <Text type="secondary" style={{ fontSize: 11, marginTop: 6, display: "block" }}>
            Selected: {selectedFile.name}
          </Text>
        )}
      </div>
    </div>
  );
};

export default LogoUpload;